/* globals elkitorg_config */

import { node_observable_component } from 'common/util/ComponentDecorator';
import ModalUtil from 'common/util/ModalUtil';

@node_observable_component
export default class CartPage {
	static classname = 'calculator';

	constructor($btn) {
		this.$btn = $btn;
		this.modalContent = this.$btn.data('modal-content');
		this.url = this.$btn.data('url');

		this.init();
	}

	init() {
		this.$btn.removeAttr('data-modal-content');
		this.initEventListeners();
	}

	initEventListeners = () => {
		const self = this;

		self.$btn.on('click', function(e) {
			e.preventDefault();
			self.openForm();
		});
	};

	openForm = () => {
		if (this.modalContent) {
			ModalUtil.openContent(this.modalContent, function () {
				/*if (typeof yaCounter26476791 != 'undefined') {
					yaCounter26476791.reachGoal('category_culc');
				}*/
			}, null, {
				enableEscapeKey: false,
				closeOnBgClick: false
			});
		} else if (this.url) {
			ModalUtil.openAjax(this.url, function (data) {
				return $(data).find('.calculator-content');
			}, null, null, {
				closeOnBgClick: false
			})
		}
	}
};
